import type { ConfigurationPanelQueryParamValue } from '@apps/main/new-desktop/core/models';

import type { Serializer } from '@libs/utils';

export const ConfigurationPanelSerializer: Serializer<ConfigurationPanelQueryParamValue> =
  {
    serialize: (
      customerOrignQueryParam: ConfigurationPanelQueryParamValue
    ): ConfigurationPanelQueryParamValue => customerOrignQueryParam,
    deserialize: (
      customerOrignQueryParam: ConfigurationPanelQueryParamValue
    ): ConfigurationPanelQueryParamValue => customerOrignQueryParam,
  };
